export default {
  saveSuccess: '保存しました',
  saveFailed: '保存に失敗しました',
  deleteSuccess: '削除しました',
  deleteFailed: '削除に失敗しました',
  updateSuccess: '更新しました',
  updateFailed: '更新に失敗しました',
  networkError: 'ネットワークエラー、後でもう一度お試しください',
  serverError: 'サーバーエラー、後でもう一度お試しください',
  timeout: 'リクエストがタイムアウトしました、後でもう一度お試しください',
  product: {
    addSuccess: '商品が正常に追加されました',
    editSuccess: '商品が正常に更新されました',
    deleteSuccess: '商品が正常に削除されました',
  },
  batch: {
    saveSuccess: 'バッチが正常に保存されました',
    saveFailed: 'バッチの保存に失敗しました',
    deleteSuccess: 'バッチが正常に削除されました',
    deleteFailed: 'バッチの削除に失敗しました',
  },
  category: {
    actionSuccess: 'カテゴリ操作が正常に実行されました',
    actionFailed: 'カテゴリ操作に失敗しました',
    deleteSuccess: 'カテゴリが正常に削除されました',
  },
  attr: {
    actionSuccess: '属性操作が正常に実行されました',
    actionFailed: '属性操作に失敗しました',
    deleteSuccess: '属性が正常に削除されました',
  },
  gift: {
    actionSuccess: 'ギフト操作が正常に実行されました',
    actionFailed: 'ギフト操作に失敗しました',
    deleteSuccess: 'ギフトが正常に削除されました',
  },
  giftCategory: {
    actionSuccess: 'ギフトカテゴリ操作が正常に実行されました',
    actionFailed: 'ギフトカテゴリ操作に失敗しました',
    deleteSuccess: 'ギフトカテゴリが正常に削除されました',
  },
  factory: {
    actionSuccess: '工場操作が正常に実行されました',
    actionFailed: '工場操作に失敗しました',
    deleteSuccess: '工場が正常に削除されました',
    deleteFailed: '工場の削除に失敗しました',
  },
  actionSuccess: '操作が成功しました',
  actionFailed: '操作に失敗しました',
  addSuccess: '追加しました',
  editSuccess: '編集しました',
  deleteSuccess: '削除しました',
  saveSuccess: '保存しました',
  saveFailed: '保存に失敗しました',
  confirmDelete: '削除してもよろしいですか？この操作は元に戻せません',
};
